module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Chronology for Francis Ford Coppola")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "2",
      "width": "100%;"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1939")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Born April 7 in Detroit, Michigan, to Carmine and Italia Coppola.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1957")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Attends Hofstra University on a drama scholarship.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1960")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Earns a Bachelor of Arts degree at Hofstra and enters the film school of the University of California at Los Angeles, where he studies on campus for two years.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1962")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Is hired by Roger Corman, an independent producer, and works on "), _c('i', [_vm._v("Battle Beyond the Sun, The Young Racers")]), _vm._v(", and other films.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1963")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Directs his first feature, "), _c('i', [_vm._v("Dementia 13")]), _vm._v(", a low-budget movie made for Corman. The assistant art director is Eleanor Neil, whom Coppola marries after completing the movie.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1966")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("As scriptwriter for Seven Arts, an independent production unit, Coppola is given a screen credit for co-scripting "), _c('i', [_vm._v("This Property Is Condemned")]), _vm._v(" and "), _c('i', [_vm._v("Is Paris Burning")]), _vm._v("?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1967")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Directs "), _c('i', [_vm._v("You’re a Big Boy Now")]), _vm._v(", his first film for a major studio; it enables him to earn his Master of Arts degree at UCLA, which is conferred the following year.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1968")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Finians Rainbow")]), _vm._v(", a musical with Fred Astaire.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1969")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Rain People")]), _vm._v(" wins the Grand Prize and the Best Director Award at the San Sebastian International Film Festival. Inaugurates American Zoetrope, an independent production unit in San Francisco.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1970")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Patton")]), _vm._v(", for which he coauthors the screenplay, wins him his first Academy Award, for Best Screenplay.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1972")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Godfather")]), _vm._v(" wins him an Academy Award for coauthoring the screenplay of the film, which he also directed; the picture is also voted the Best Picture of the Year.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1974")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Conversation")]), _vm._v(" wins the Grand Prize at the Cannes International Film Festival. "), _c('i', [_vm._v("The Great Gatsby")]), _vm._v(", the last picture for "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("which he wrote a script without directing the film, is released. "), _c('i', [_vm._v("The Godfather "), _c('span', {
    attrs: {
      "href": "#/html/14_9780813123042_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])]), _vm._v(" wins him Academy Awards for Best Director and for coauthoring the screenplay; the film becomes the only sequel up to that time to be voted Best Picture of the Year.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1979")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Apocalypse Now")]), _vm._v(", which had an unprecedented shooting period of 238 days, wins him his second Grand Prize at the Cannes International Film Festival; one of the first major films to deal with the Vietnam War.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1980")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Inaugurates Zoetrope Studios in Hollywood.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1982")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("One from the Heart")]), _vm._v(", a commercial failure, forces him to close his independent studio in Hollywood; he continues to run an independent production unit, American Zoetrope, in San Francisco, producing films for release by major studios in Hollywood.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1983")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Outsiders")]), _vm._v(" and "), _c('i', [_vm._v("Rumble Fish")]), _vm._v(" are made back-to-back in Oklahoma.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1984")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Assumes direction of "), _c('i', [_vm._v("The Cotton Club")]), _vm._v(", a film with a troubled production history up to that point.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1985")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("“Rip Van Winkle,” a telefilm, is first broadcast.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1986")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Peggy Sue Got Married")]), _vm._v(" becomes a major hit.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1987")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Gardens of Stone")]), _vm._v(", his second film set during the Vietnam War.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1988")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Tucker: The Man and His Dream")]), _vm._v(", after some false starts, is finally made.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1989")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("New York Stories")]), _vm._v(", an anthology film with segments by Martin Scorsese, Woody Allen, and Coppola.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1990")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Godfather "), _c('span', {
    attrs: {
      "href": "#/html/18_9780813123042_part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")])]), _vm._v(", the final sequel to "), _c('i', [_vm._v("The Godfather")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1991")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Fax Bahr and George Hickenlooper’s feature-length documentary "), _c('i', [_vm._v("Hearts of Darkness")]), _vm._v(", about the making of "), _c('i', [_vm._v("Apocalypse Now")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1992")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Bram Stoker’s Dracula")]), _vm._v(" is a commercial success; Coppola receives a Golden Lion as a Life Achievement Award at the Venice International Film Festival.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1995")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("The National Film Registry of the Library of Congress, which preserves films of enduring quality, includes "), _c('i', [_vm._v("The Godfather, The Godfather "), _c('span', {
    attrs: {
      "href": "#/html/14_9780813123042_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])]), _vm._v(", and "), _c('i', [_vm._v("The Conversation")]), _vm._v(" in its collection.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1996")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Jack")]), _vm._v(", a vehicle for Robin Williams.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1997")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("The Rainmaker")]), _vm._v(", from the John Grisham novel.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1998")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Recipient of the Life Achievement Award, the highest honor that can be bestowed by the Directors Guild of America. A jury orders Warner Brothers to pay him $80 million for reneging "), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("on a deal to film "), _c('i', [_vm._v("Pinocchio")]), _vm._v("—the largest victory by a filmmaker over a major studio up to that time.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1999")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("American Zoetrope, Coppola’s production unit, releases "), _c('i', [_vm._v("The Virgin Suicides")]), _vm._v(", written and directed by his daughter Sofia.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2000")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Coppola edits (uncredited) the release version of "), _c('i', [_vm._v("Supernova")]), _vm._v(", after the director, Walter Hill, departs the project.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2001")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Theatrical release of "), _c('i', [_vm._v("Apocalypse Now Redux")]), _vm._v(", with fifty minutes of additional footage added to the film as originally released. Release on DVD of "), _c('i', [_vm._v("The Godfather Trilogy,")]), _vm._v(" with a documentary about the making of the three films.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2002")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("Gala tribute by the Film Society of Lincoln Center of New York for his lifetime achievement in the cinema, May 7. American Zoetrope releases "), _c('i', [_vm._v("CQ")]), _vm._v(", written and directed by Coppola’s son Roman. "), _c('i', [_vm._v("Sight and Sound’s")]), _vm._v(" international poll of film directors and film critics chooses Coppola as one of the top ten directors of all time and "), _c('i', [_vm._v("The Godfather")]), _vm._v(" and "), _c('i', [_vm._v("The Godfather "), _c('span', {
    attrs: {
      "href": "#/html/14_9780813123042_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])]), _vm._v(" among the top ten films of all time.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2003")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_c('i', [_vm._v("Premiere")]), _vm._v(" magazine conducts a nationwide poll for the one hundred greatest films, and "), _c('i', [_vm._v("The Godfather "), _c('span', {
    attrs: {
      "href": "#/html/14_9780813123042_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])]), _vm._v(" leads the list in first place. The American Film Institute honors the best one hundred heroes and villains in cinema history with a TV special aired on June 3, including Michael Corleone in "), _c('i', [_vm._v("Godfather II")]), _vm._v(" as a legendary villain. The Motion Picture Academy sponsors a screening of "), _c('i', [_vm._v("One from the Heart")]), _vm._v(", with Coppola leading a discussion of the film. Francis Coppola serves as an executive producer for American Zoetrope on Sofia Coppola’s second feature, "), _c('i', [_vm._v("Lost in Translation.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2004")]), _c('td', {
    staticClass: "td2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenttd"
  }, [_vm._v("A nationwide poll published by "), _c('i', [_vm._v("Premiere")]), _vm._v(" magazine lists "), _c('i', [_vm._v("The Godfather")]), _vm._v(" as one of the seventy-five most influential films of all time, because it raised the gangster film to the level of a cinematic epic.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d884881","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_9780813123042_chronology.vue
// module id = 78
// module chunks = 0